import i18next from "i18next";
import { initReactI18next } from "react-i18next";

//Import all translation files
import translationEnglish from "./Translation/English/translation.json";
import translationItalian from "./Translation/Italian/translation.json";

//Import translation2 file
// import translationEnglishSecondFile from "./Translation/English/translation2.json";

//---Using different namespaces
const resources = {
    en: {
        translation: translationEnglish,
    },
    it: {
        translation: translationItalian,
    },
}

i18next
.use(initReactI18next)
.init({
  resources,
  lng:"it", //default language
});

export default i18next;